<template>
  <div class="bar-chart-container container" id="betting-graph">
    <div class="title">
      <h1>NFL Revenue Categories</h1>
      <h2>Differential: NF VS AB</h2>
    </div>
    
    <div class="buttons">
      <button
        v-for="(bettor, index) in bettorTypes"
        :key="`bettor-button-${index}`"
        :class="{ active: activeCategories[index] }"
        :style="`background-color: ${colors[index]}; color: ${index < 2 ? 'black' : 'white' }`"
        @click="toggleCategory(index)"
      >
        {{ bettor }}
      </button>
    </div>

    <div class="categories side-list">
      <ul>
        <li v-for="(stat, index) in stats" :key="`category-${index}`">
          {{ stat.name }}
        </li>
      </ul>
    </div>
    <div class="percentages side-list">
      <ul v-if="highestShown != -1">
        <li v-for="(stat, index) in stats" :key="`percent-${index}`">
          {{ `${highestShown != 4 ? '$' : ''}${stat.data[highestShown]}${highestShown == 4 ? '%' : ''}` }}
        </li>
      </ul>
    </div>
    
    <svg id="betting-graphic">
    </svg>

    <p
      class="footnote"
      :class="{ visible: activeCategories[4] }"
      :style="`color: ${this.colors[4]}`"
    >
      *Differential shows the growth of revenue when comparing "no interest fans" with "active bettors"
    </p>
  </div>
</template>

<script>
import * as d3 from 'd3'
export default {
  data () {
    return {
      bettorTypes: [
        'No Interest',
        'Moderate Interest',
        'High Interest',
        'Active Bettors',
        'Differential'
      ],
      activeCategories: {
        0: true,
        1: false,
        2: false,
        3: false,
        4: false
      },
      colors: [
        '#d2ffd2', '#96e696', '#46a046', '#1e7832', '#0a5028'
      ],
      rects: [],
      graphicContainer: null,
      rows: [],
      graphicDrawn: false,
      stats: [
        {
          name: 'Subscriptions',
          data: [5.22, 15.95, 37.46, 47.74, 915]
        },
        {
          name: 'Concessions',
          data: [0.67, 2.30, 5.31, 5.37, 802]
        },
        {
          name: 'Madden',
          data: [3.88, 13.32, 23, 26.94, 694]
        },
        {
          name: 'NFL',
          data: [0.91, 2.11, 4.98, 5.33, 586]
        },
        {
          name: 'Gate Revenue',
          data: [10.16, 24.48, 54.45, 55.15, 543]
        },
        {
          name: 'Merchandise',
          data: [6.53, 17.02, 28.84, 30.48, 467]
        },
        {
          name: 'Radio',
          data: [1.35, 2.35, 4.08, 4.37, 324]
        },
        {
          name: 'NFL Network',
          data: [8.58, 11.33, 22.38, 22.49, 262]
        },
        {
          name: 'TNF',
          data: [6.09, 7.77, 12.58, 13.24, 217]
        },
        {
          name: 'MNF',
          data: [10.30, 12.61, 18.32, 19.13, 186]
        },
        {
          name: 'Sponsorships',
          data: [20.47, 25.37, 37.33, 36.98, 181]
        },
        {
          name: 'Sunday Regional',
          data: [28.42, 37.31, 46.70, 49.90, 176]
        },
        {
          name: 'SNF',
          data: [9.34, 12.24, 16.22, 16.44, 176]
        },
        {
          name: 'Sunday National',
          data: [28.88, 35.66, 47.62, 49.89, 173]
        },
        {
          name: 'Super Bowl',
          data: [1.02, 1.22, 1.49, 1.47, 144]
        }
      ]
    }
  },
  computed: {
    highestShown () {
      let highest = -1
      Object.entries(this.activeCategories).forEach(([key, value]) => {
        if (value && key > highest) {
          highest = key
        }
      })
      return highest
    }
  },
  mounted () {
    this.drawGraphic()

    window.addEventListener('resize', () => {
      this.drawGraphic()
    })
  },
  methods: {
    toggleCategory (index) {
      // console.log(`Toggle category ${index}`)
      if (index == 4) {
        for (let i = 0; i < 4; i++) {
          this.activeCategories[i] = this.activeCategories[4]
        }
      } else {
        this.activeCategories[4] = false
      }
      this.activeCategories[index] = !this.activeCategories[index]
      this.drawGraphic()
    },
    drawGraphic () {
      // console.log('Draw graphic')
      const graphicElement = document.getElementById('betting-graphic')
      const styles = window.getComputedStyle(graphicElement)
      const graphicPadding = parseFloat(styles.paddingLeft) + parseFloat(styles.paddingRight)
      const graphicWidth = graphicElement.clientWidth - graphicPadding
      const padding = 5

      let longest = 0
      this.stats.forEach((stat) => {
        let total = 0
        stat.data.forEach((data, index) => {
          if (this.activeCategories[index]) {
            total += data
          }
        })
        if (total > longest) {
          longest = total
        }
      })
      const scaleFactor = graphicWidth / longest

      // d3.selectAll('svg g').remove()
      const graphic = d3.select('svg')
      document.getElementById('betting-graphic').style.height = `${this.stats.length * 25}px`
      
      if (!this.graphicDrawn) {
        this.graphicContainer = graphic.append('g')
          .attr('height', 500)
          .attr('id', 'betting-graphic-container')
      }
      
      for (let i = 0; i < this.stats.length; i++) {
        if (!this.graphicDrawn) {
          this.rects[i] = []
          this.rows[i] = this.graphicContainer.append('g')
        }
        let runningTotal = 0
        this.stats[i].data.forEach((data, j) => {
          
          let width = data * scaleFactor

          if (!this.activeCategories[j]) {
            width = 0
          }

          if (!this.graphicDrawn) {
            const currentRect = this.rows[i].append('rect')
              .attr('class', 'segment')
              .attr('y', i * 20 + (padding * i))
              .attr('x', runningTotal)
              .attr('width', width)
              .attr('fill', this.colors[j])
            
            this.rects[i].push(currentRect)
          } else {
            this.rects[i][j]
              .attr('x', runningTotal)
              .attr('width', width)
          }
          
          runningTotal += width
        })
      }
      this.graphicDrawn = true
    },
    updateGraphic () {

    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/_variables';
@import '@/assets/style/_articles';

.bar-chart-container {
  position: relative;

  #betting-graphic {
    @include media($bp-desktop-s) {
      padding: 0 $space-l 0 0;
    }
  }

  .title {
    margin-bottom: $space-s;
  }
  .buttons {
    margin-bottom: $space-s;
  }
  .side-list {
    position: absolute;
    ul {
      font-size: $font-size-article-xs;
      line-height: 20px;
      list-style: none;
      padding: 0;
      li {
        padding-bottom: 5px;
      }
    }
  }
  .categories {
    transform: translateX(-100%);
    ul {
      padding-right: $space-s;
      color: black;
      text-shadow:
        -1px -1px 0 #fff,  
        1px -1px 0 #fff,
        -1px 1px 0 #fff,
        1px 1px 0 #fff;
    }
    @include media ($bp-desktop-s) {
      transform: none;
      padding-left: $space-xs;
    }
  }
  .percentages {
    right: 0;
    transform: translateX(100%);
    @include media ($bp-desktop-s) {
      transform: none;
      right: $space-s;
    }
  }
  button {
    padding: 10px 15px;
    margin: 0 5px 5px 0;
    filter: saturate(0.2);
    font-size: $font-size-article-xs;

    @include media($bp-tablet) {
      padding: 5px 10px;
    }

    &.active {
      filter: saturate(1);
    }
  }

  svg {
    width: 100%;
    height: auto;
  }

  ::v-deep .segment {
    height: 20px;
    transition: .3s all;
  }

  .footnote {
    font-size: $font-size-article-xs;
    opacity: 0;
    transform: translateY(50%);
    margin: 0;
    transition: .5s all;

    &.visible {
      opacity: 1;
      transform: translateY(0);
      transition: .5s all;
    }
  }
}
</style>